<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.25 7.25V5.75H5.75V7.25M12 6V18.25M12 18.25H10.75M12 18.25H13.25" stroke="#334155" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: "text-box-search-icon",
};
</script>

<style scoped>

</style>
